import axios, { AxiosInstance } from 'axios';
import Cookies from 'js-cookie';
import moment from 'moment';

class ApiService {
  TIMEOUT = 20000;

  INSTANCE: AxiosInstance = undefined;

  TOKEN = '';

  Interceptors = [];

  constructor() {
    if (!this.INSTANCE) {
      this.INSTANCE = axios.create({
        baseURL: process.env.BASE_URL_API,
        timeout: this.TIMEOUT,
      });
    }
  }

  addAuthorizationHeader = (token: string) => {
    token && (this.TOKEN = token);
    const interceptorId = this.INSTANCE.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
    this.Interceptors.push(interceptorId);
    return interceptorId;
  };

  removeAllInterceptor = () => {
    this.Interceptors.map((interceptorId) =>
      this.INSTANCE.interceptors.request.eject(interceptorId)
    );
  };

  login = async (params) => {
    const response = await this.INSTANCE.post('auth/login', params);
    const { token, expired } = response.data;
    Cookies.set('token', token);
    Cookies.set('expired', expired);
    this.addAuthorizationHeader(token);
    return token;
  };

  register = async (params) => {
    const response = await this.INSTANCE.post('auth/register', params);
    return response.data;
  };

  fetchPageData = async (url) => {
    const response = await this.INSTANCE.get(url);
    return response?.data;
  };

  createData = async (url, params, isFormData = false) => {
    const response = await this.INSTANCE.post(url, params, {
      headers: {
        'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
      },
    });
    return response?.data;
  };

  updateData = async (url, params, isFormData = false) => {
    const response = await this.INSTANCE.put(url, params);
    return response?.data;
  };

  deleteData = async (url) => {
    const response = await this.INSTANCE.delete(url);
    return response?.data;
  };

  sendEmail = async (params) => {
    const response = await this.INSTANCE.post('send-mail', params);
    return response?.data;
  };

  uploadImage = async (params) => {
    const response = await this.INSTANCE.post('uploads', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response?.data;
  };

  uploadImageToAlbum = async (params) => {
    const response = await this.INSTANCE.post('upload-gallery', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response?.data;
  };

  deleteImage = async (imageId) => {
    const response = await this.INSTANCE.delete(`image/${imageId}`);
    return response?.data;
  };
}

export default new ApiService();
